import './App.css';
import Dictionary from './Dictionary';

function App() {
  return (
    <div className="App">
      <Dictionary />
      <footer className="App-footer">
        Coded by Kelly Singer Lançon:{" "}
        <a href="https://github.com/kellyisasinger17">Github</a> +{" "}
        <a href="https://interactivedictionaryapp.netlify.app/">Netlify</a>
      </footer>
    </div>
  );
}

export default App;
